import { space } from '@synoptic/ui-kit/tokens.ts';
import { style } from '@vanilla-extract/css';
import { uploadPreviewContainer } from '../upload-preview/upload-preview.css.ts';

export const imageUploadPreviewContainer = style([uploadPreviewContainer]);

export const actionsContainer = style({
  position: 'absolute',
  display: 'flex',
  gap: space.s8,
  alignItems: 'center',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  visibility: 'hidden',
  transition: 'visibility 0.1s',

  selectors: {
    [`${imageUploadPreviewContainer}:hover &`]: {
      visibility: 'visible',
    },
  },
});
